import addDays from 'date-fns/addDays'
import {TOKEN_EXPIRE_MAPPER} from './constants'

/**
 * Get the cookie via provided ruleAction
 * @param ruleAction - access control action code
 */
export const getCookieAgeFromAction = ruleAction =>
  addDays(new Date(), TOKEN_EXPIRE_MAPPER[ruleAction]).toISOString()
